function renderIconicBadges(component) {
  if (!component) return;

  // Clear previous content (important for theme editor)
  component.innerHTML = "";

  const settings = JSON.parse(component.dataset.settings);

  const wrapper = document.createElement("div");
  wrapper.style.display = "flex";
  wrapper.style.flexWrap = "wrap";
  wrapper.style.gap = "8px";
  wrapper.style.rowGap = "10px";

  // Alignment
  if (settings.badge_alignment === "start") {
    wrapper.style.justifyContent = "flex-start";
  } else if (settings.badge_alignment === "end") {
    wrapper.style.justifyContent = "flex-end";
  } else {
    wrapper.style.justifyContent = "center";
  }

  // Responsive margin
  function applyMargin() {
    const isMobile = window.innerWidth < 768;
    const margin = isMobile
      ? Math.round(settings.badges_margin_top_bottom * 0.75)
      : settings.badges_margin_top_bottom;

    wrapper.style.marginTop = margin + "px";
    wrapper.style.marginBottom = margin + "px";
  }

  applyMargin();
  window.addEventListener("resize", applyMargin);

  // Generate badges 1..6
  for (let i = 1; i <= 6; i++) {
    const text = settings[`badge_${i}_text`];
    const bg = settings[`badge_${i}_bg`];
    const color = settings[`badge_${i}_color`];

    if (!text) continue;

    const badge = document.createElement("span");

    // Inline style (no CSS class needed)
    badge.style.fontWeight = "600";
    badge.style.borderRadius = "18px";
    badge.style.whiteSpace = "nowrap";
    badge.style.padding = "6px 12px";
    badge.style.backgroundColor = bg;
    badge.style.color = color;
    badge.style.textTransform = settings.heading_transform;

    const applyFont = () => {
      const isMobile = window.innerWidth < 768;
      const fontSize = isMobile
        ? settings.badge_font_size * 0.75
        : settings.badge_font_size;

      badge.style.fontSize = fontSize + "px";
      badge.style.lineHeight = fontSize + 5 + "px";
    };

    applyFont();
    window.addEventListener("resize", applyFont);

    badge.textContent = text;
    wrapper.appendChild(badge);
  }

  component.appendChild(wrapper);
}


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".iconic-badges-first-js").forEach(renderIconicBadges);
});

[
  "shopify:section:load",
  "shopify:section:select",
  "shopify:section:deselect",
  "shopify:section:reorder",
  "shopify:block:select",
  "shopify:section:unload"
].forEach(evt => {
  document.addEventListener(evt, (e) => {
    const container =
      e.target.querySelector(".iconic-badges-first-js") ||
      e.target.closest("section")?.querySelector(".iconic-badges-first-js");

    if (container) renderIconicBadges(container);
  });
});